import React from "react";

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="topbar-track">
        <span>
          ✨ Free Shipping on Orders Above ₹999 &nbsp;&nbsp; | &nbsp;&nbsp;
          💎 Premium Quality Jewellery &nbsp;&nbsp; | &nbsp;&nbsp;
          🔥 Flat 20% Off on Selected Items
        </span>
        <span>
          ✨ Free Shipping on Orders Above ₹999 &nbsp;&nbsp; | &nbsp;&nbsp;
          💎 Premium Quality Jewellery &nbsp;&nbsp; | &nbsp;&nbsp;
          🔥 Flat 20% Off on Selected Items
        </span>
      </div>
    </div>
  );
};

export default TopBar;
